function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.0645 25.2121C32.3357 36.261 30.1632 56.3473 41.2121 70.0761C45.5563 75.4739 28.2975 88.7763 34.5 90.5C44.0731 93.1604 77.7451 81.6332 86.0761 74.9284C99.8049 63.8795 101.977 43.7933 90.9285 30.0645C79.8796 16.3357 59.7933 14.1632 46.0645 25.2121Z",
  fill: "white",
  stroke: "url(#paint0_linear)",
  strokeWidth: 5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.794 61.69C68.926 63.79 67.106 64.84 64.334 64.84C62.906 64.84 61.744 64.35 60.848 63.37C60.092 62.502 59.714 61.634 59.714 60.766C59.714 58.498 60.232 55.152 61.268 50.728L62.822 42.58L71.348 41.74L68.786 55.012C68.31 57.084 68.072 58.484 68.072 59.212C68.072 60.808 68.646 61.634 69.794 61.69ZM63.578 36.742C63.578 35.65 64.026 34.81 64.922 34.222C65.846 33.634 66.966 33.34 68.282 33.34C69.598 33.34 70.648 33.634 71.432 34.222C72.244 34.81 72.65 35.65 72.65 36.742C72.65 37.834 72.202 38.66 71.306 39.22C70.438 39.78 69.346 40.06 68.03 40.06C66.714 40.06 65.636 39.78 64.796 39.22C63.984 38.66 63.578 37.834 63.578 36.742Z",
  fill: "url(#paint1_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 82.0926,
  y1: 19.0855,
  x2: 86.3922,
  y2: 90.7109,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 52.6889,
  y1: 49.2022,
  x2: 69.3576,
  y2: 53.3763,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#CF48FF"
}), React.createElement("stop", {
  offset: 0.390624,
  stopColor: "#AE46FF"
}), React.createElement("stop", {
  offset: 0.942708,
  stopColor: "#6831DE"
})));

var SvgAboutUs = function SvgAboutUs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAboutUs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AboutUs.57cdba97.svg";
export { ForwardRef as ReactComponent };